import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';
import { AuthGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';
import DashboardLayout from 'src/layouts/dashboard/layout';
import { paths } from '../../paths';

const CreateVideoAiPage = lazy(() =>
  import('src/pages/dashboard/services/ai-services/create-video-service')
);

const VideoAiServicePage = lazy(() =>
  import('src/pages/dashboard/services/ai-services/video-ai-service')
);

const ImagesVideoAiServerPage = lazy(() =>
  import('src/pages/dashboard/services/images-ai-service/images-ai-service')
);

const CreateImageAiServicePage = lazy(() =>
  import('src/pages/dashboard/services/images-ai-service/create-image-ai-service')
);

const MusicAIServicePage = lazy(() =>
  import('src/pages/dashboard/services/music-service/music-ai-service')
);

const CreateMusicAIServicePage = lazy(() =>
  import('src/pages/dashboard/services/music-service/create-music-ai-service')
);

const AudioAiServicePage = lazy(() =>
  import('src/pages/dashboard/services/audio-service/audio-ai-service')
);

const CreateAudioAiService = lazy(() =>
  import('src/pages/dashboard/services/audio-service/create-audio-ai-service')
);

// ----------------------------------------------------------------------

export const aiRoutes = [
  {
    path: '',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: paths.ai.root, element: <Navigate to={paths.ai.video_ai} replace /> },
      { path: paths.ai.video_ai, element: <VideoAiServicePage /> },
      { path: paths.ai.create_video, element: <CreateVideoAiPage /> },
      { path: paths.ai.image_ai, element: <ImagesVideoAiServerPage /> },
      { path: paths.ai.create_image, element: <CreateImageAiServicePage /> },
      { path: paths.ai.music, element: <MusicAIServicePage /> },
      { path: paths.ai.create_music, element: <CreateMusicAIServicePage /> },
      { path: paths.ai.audio, element: <AudioAiServicePage /> },
      { path: paths.ai.create_audio, element: <CreateAudioAiService /> },
    ],
  },
];
